var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebProfileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "account-circle",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M12,24A11.985,11.985,0,0,1,3.525,3.525a11.985,11.985,0,1,1,16.95,16.95A11.914,11.914,0,0,1,12,24Zm0-10.92a12.833,12.833,0,0,0-4.5.96c-1.232.517-2.7,1.416-2.7,2.761a8.672,8.672,0,0,0,14.4,0c0-1.344-1.468-2.243-2.7-2.761A12.833,12.833,0,0,0,12,13.08ZM12,3.6A3.521,3.521,0,0,0,8.4,7.2,3.521,3.521,0,0,0,12,10.8a3.521,3.521,0,0,0,3.6-3.6A3.521,3.521,0,0,0,12,3.6Z",
    transform: "translate(0 0)",
    fill: "#36495a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebProfileIcon);
export default __webpack_public_path__ + "static/media/Web_Profile_Icon.9a923770f1b8464ff786e783a28ccd34.svg";
export { ForwardRef as ReactComponent };